import React from 'react';
import { useLocation } from 'react-router-dom';

function getEnv(variable) {
  var _window$env;
  return process.env[variable] || ((_window$env = window.env) === null || _window$env === void 0 ? void 0 : _window$env[variable]);
}

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  var _useLocation = useLocation(),
    search = _useLocation.search;
  return React.useMemo(function () {
    return new URLSearchParams(search);
  }, [search]);
}

export { getEnv as g, useQuery as u };
